<script>
    import { onMount, onDestroy } from 'svelte';
    export let selectedItem;
    export let deliveries;
    export let transportes;
    export let vehiculos;
    export let escoltas;

    let deliveryMap;
    let deliveryMarker;
    // Selected escoltas array
    let selectedEscoltas = [];

    // Initialize delivery map
    function initializeDeliveryMap() {
      if (!selectedItem) return;
  
      let deliveryRef = selectedItem.geo_delivery_ref;
      if (deliveryRef) {
        const [lat, lng] = deliveryRef.split(',').map(parseFloat);
        initMap('delivery-map-canvas', lat, lng, true);
      } else {
        initMap('delivery-map-canvas', 14.603032776408446, -90.53445609626046, true);
      }
    }
  
    // Initialize a Google Map
    function initMap(mapId, lat, lng, isDelivery = false) {
      const google = window.google;
      if (!google) {
        console.error('Google Maps not loaded');
        return;
      }
  
      const mapElement = document.getElementById(mapId);
      if (!mapElement) {
        console.error('Map canvas element not found:', mapId);
        return;
      }
  
      const myLatlng = new google.maps.LatLng(lat, lng);
      const mapOptions = {
        zoom: 16,
        scrollwheel: false,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
          // Map styles...
        ],
      };
  
      const mapInstance = new google.maps.Map(mapElement, mapOptions);
      const markerInstance = new google.maps.Marker({
        position: myLatlng,
        map: mapInstance,
        animation: google.maps.Animation.DROP,
        title: isDelivery ? "Ubicación de entrega" : "Ubicación destino",
        draggable: true
      });
  
      if (isDelivery) {
        deliveryMap = mapInstance;
        deliveryMarker = markerInstance;
      }
  
      // Add event listeners for dragend and click...
    }
  
    onMount(() => {
      initializeDeliveryMap();
    });
  
    onDestroy(() => {
      if (deliveryMarker) deliveryMarker.setMap(null);
      if (deliveryMap) google.maps.event.clearInstanceListeners(deliveryMap);
    });

    // Get escolta names for display
  function getEscoltaNames() {
    if (!selectedEscoltas || selectedEscoltas.length === 0) return 'Ninguno seleccionado';
    
    if (!selectedItem.escoltas || !Array.isArray(selectedItem.escoltas) || selectedItem.escoltas.length === 0) {
      return 'Ninguno seleccionado';
    }
    
    const names = selectedItem.escoltas
      .map(e => {
        // Access the expanded escolta data correctly
        if (e.expand && e.expand.escolta && e.expand.escolta.nombre) {
          return e.expand.escolta.nombre;
        }
        // Fallback if expand structure isn't available
        return null;
      })
      .filter(Boolean)
      .join(', ');
      
    return names || 'Ninguno seleccionado';
  }

  // Load existing escoltas if any
  function loadExistingEscoltas() {
    console.log("Loading existing escoltas from:", selectedItem.escoltas);
    
    if (selectedItem && selectedItem.escoltas) {
      // Ensure it's an array
      if (Array.isArray(selectedItem.escoltas)) {
        // Extract just the escolta IDs from the objects
        selectedEscoltas = selectedItem.escoltas.map(escoltaItem => {
          // If it's the expanded structure from the JSON
          if (escoltaItem.escolta) {
            return escoltaItem.escolta;
          }
          // If it's already just the ID
          else if (typeof escoltaItem === 'string') {
            return escoltaItem;
          }
          // If it has an id property (fallback)
          else if (escoltaItem.id) {
            return escoltaItem.id;
          }
          return null;
        }).filter(Boolean); // Remove any null values
      } else {
        // Handle case where escoltas might be an object or string
        try {
          // Try to parse it if it's a string representation of array
          const parsed = typeof selectedItem.escoltas === 'string' 
            ? JSON.parse(selectedItem.escoltas) 
            : selectedItem.escoltas;
          
          if (Array.isArray(parsed)) {
            // Extract IDs using the same mapping logic
            selectedEscoltas = parsed.map(escoltaItem => {
              if (escoltaItem.escolta) {
                return escoltaItem.escolta;
              } else if (typeof escoltaItem === 'string') {
                return escoltaItem;
              } else if (escoltaItem.id) {
                return escoltaItem.id;
              }
              return null;
            }).filter(Boolean);
          } else {
            selectedEscoltas = [];
          }
        } catch (e) {
          console.error("Error parsing escoltas:", e);
          selectedEscoltas = [];
        }
      }
      
      console.log("Existing escoltas loaded:", selectedEscoltas);
    } else {
      selectedEscoltas = [];
    }
  }
  // Call on component initialization
  loadExistingEscoltas();
</script>
  
  <div class="space-y-4">
    <div>
      <div class="mt-2 text-sm text-blueGray-600">
        Para actualizar la ubicación de entrega: 
        • Arrastre el marcador a la nueva ubicación, o
        • Haga clic en el mapa para colocar el marcador
      </div>
      <h2 class="text-lg font-bold text-blueGray-700 mb-4">Ubicación de entrega del pedido</h2>
      <p><strong>Repartidor:</strong> {deliveries.find(d => d.id === selectedItem.delivery)?.nombre || 'No seleccionado'}</p>
      <p><strong>Referencia:</strong>{selectedItem.delivery_ref}</p>
      <p><strong>Vehículo:</strong> {selectedItem.vehiculo ? 
        `${vehiculos.find(v => v.id === selectedItem.vehiculo)?.placa} / ${vehiculos.find(v => v.id === selectedItem.vehiculo)?.marca} ${vehiculos.find(v => v.id === selectedItem.vehiculo)?.modelo} (${vehiculos.find(v => v.id === selectedItem.vehiculo)?.color})` 
        : 'No seleccionado'}</p>
      <p><strong>Escoltas:</strong> {getEscoltaNames()}</p>
      <p><strong>Referencia:</strong> {selectedItem.target_ref || 'Sin referencia'}</p>
    
      <p><strong>Transporte:</strong> {transportes.find(c => c.id === selectedItem.transporte)?.descrip || 'No seleccionado'}</p>
      <p><strong>Referencia:</strong> {selectedItem.transporte_ref || 'Sin referencia'}</p>
      <div
        id="delivery-map-canvas"
        class="relative w-full rounded h-96 mt-4"
        style="min-height: 400px;"
      ></div>
    </div>
  </div>